<template>
  <v-btn-toggle
    :disabled="disabled"
    :value="value"
    class="status-toggle-compact"
    dense
    mandatory
    @change="validateAndEmitChange"
  >
    <v-btn
      v-for="statusValue in availableValues"
      :key="statusValue"
      :color="getValueColor(statusValue)"
      :value="statusValue"
      class="px-2"
    >
      <v-icon>{{ getValueIcon(statusValue) }}</v-icon>
    </v-btn>
  </v-btn-toggle>
</template>

<script>
  export default {
    name: 'ChecklistStatusToggle',
    props: {
      value: {
        type: String,
        default: 'pending'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      availableValues: {
        type: Array,
        default: () => ['pending', 'checked', 'not_required']
      }
    },
    methods: {
      getValueColor(value) {
        const colors = {
          'pending': 'warning',
          'checked': 'success',
          'not_required': 'grey'
        }
        return colors[value] || 'grey'
      },
      getValueIcon(value) {
        const icons = {
          'pending': 'schedule',
          'checked': 'check_circle',
          'not_required': 'block'
        }
        return icons[value] || 'help'
      },
      validateAndEmitChange(newValue) {
        // Solo validar cuando cambiamos a 'checked'
        if (newValue === 'checked') {
          this.$emit('validate-custom-check', newValue, (isValid) => {
            if (isValid) {
              // Solo emitir el cambio si la validación fue exitosa
              this.$emit('change', newValue)
            } else {
              // Si la validación falla, no emitir cambio
              // y asegurarse de que el botón toggle refleje el estado original
              this.$nextTick(() => {
                // Forzamos manualmente las clases active en los botones correctos
                const buttons = this.$el.querySelectorAll('.v-btn')
                buttons.forEach(btn => {
                  if (btn.getAttribute('value') === this.value) {
                    btn.classList.add('v-btn--active')
                  } else {
                    btn.classList.remove('v-btn--active')
                  }
                })
              })
            }
          })
        } else {
          // Para otros valores, emitir directamente
          this.$emit('change', newValue)
        }
      }
    }
  }
</script>

<style scoped>
  .status-toggle-compact .v-btn {
    min-width: 32px !important;

    width: 24px !important;
    height: 24px !important;

    .v-icon {

      font-size: 16px !important;
    }
  }

  .status-toggle-compact .v-btn:not(.v-btn--active) {
    background-color: #f0f0f0 !important;
    color: #666 !important;
  }

  .status-toggle-compact .v-btn:not(.v-btn--active) .v-icon {
    color: #999 !important;
  }

  .status-toggle-compact .v-btn.v-btn--active {
    color: white !important;
  }

  .status-toggle-compact .v-btn.v-btn--active .v-icon {
    color: white !important;
  }
</style>
